module.exports = __webpack_public_path__ + "static/media/bettr-background.f317eb4f.png";